
import {  AddMaskingDetails,  GetMaskingDetailsById } from "../apiconstants/constants";
import { useState, useEffect } from 'react';
import Axios from "axios";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Swal from "sweetalert2";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { Link, useLocation } from "react-router-dom";
import defaultimg from "../assets/images/icons8-circled-user-male-skin-type-3-100.png"
import LoadingSpinner from "../helpers/loadingspinner";
function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
const Masking = () => {
    const guid = localStorage.getItem("guid");

  const [isDisabled, setIsDisabled] = useState(false);
  const [isempedit, setempEdit] = useState(null);
  var apiUrl = {};
  const { register, handleSubmit, setValue, formState } = useForm();
  const { errors } = formState
  const { isSubmitting } = formState;
  const [file, setFile] = useState();
  const [fileName, setFileName] = useState(null);
  const [imgfilepath, setimgFilepath] = useState(null);
  const [photoURL, setPhotoURL] = useState(null);
  const [fileURL, setFileURL] = useState();
  const [isLoading, setIsLoading] = useState(false)
   let Guid="";

    const userguid = localStorage.getItem("guid");
    const employerGuid = localStorage.getItem("employerGuid")
    const email = localStorage.getItem("email")
    const token = localStorage.getItem("jwtToken");
    const roleID = localStorage.getItem("roleID")

    if (roleID == 3) {
        Guid = employerGuid
    } else {
        Guid = userguid
    }
  const onSubmit = (data, e) => {
    e.preventDefault();

    UpdateData(data)
    return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 5000);
    });

  }
  const UpdateData = async(data) => {
    
       const filterData= {
        "employerGuid": guid,
        "fullName": data.fullName,
        "email": data.email,
        "phoneNumber": data.phoneNumber,
        "linkdinUrl": data.linkdinUrl
      }

    apiUrl = AddMaskingDetails.APIURL;
    Axios.post(apiUrl, filterData, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      }
    })
      .then((result) => {
        if (result.data === "added successfully") {
          GetConsultantProfile();
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Added Successfully ',
            showConfirmButton: false,
            timer: 5000
          })
              }
        }).catch(
        function (error) {
          console.log("Error" + error)
        })
  }


  useEffect(() => {
    GetConsultantProfile();
  }, []);


  const GetConsultantProfile = () => {
    setIsLoading(true)
    const GetapiUrl = GetMaskingDetailsById.APIURL+ `?EmployerGuid=${Guid}`;
    const fliterdata = {
      "EmployerGuid": Guid

    };
    Axios.get(GetapiUrl, fliterdata, {
      headers: {
       
        'Authorization': `Bearer ${token}`,
      }
    })
      .then((result) => {
        setIsLoading(false)
        setValue("fullName", result.data.fullName)
        setValue("email", result.data.email)
        setValue("linkdinUrl", result.data.linkdinUrl)
        setValue("phoneNumber", result.data.phoneNumber)
     
        if (result.data == "No Data") {
          setempEdit(null);
        }
        else {
          setempEdit("true");
        }
      }).catch(
        function (error) {
          console.log("Error" + error)
        })
  }
  return (
    <ConsultantLayout>
    <section>
    {isLoading ? <center><LoadingSpinner /></center> :

      <div className="container-fluid mt-4 pb-5">

        {/* <h2 style={{color:"#00a7ac",textAlign:"center"}}>
         Edit Profile
        </h2> */}
         <div className='row'>
           <div className='col-sm-12 col-lg-6 col-xl-6 col-md-6  mt-3'>
           <h2 className="" style={{color:"#00a7ac"}} >Masking Details</h2>
      </div>
           
        
           </div>
<hr/>
        <form onSubmit={handleSubmit(onSubmit)} >
          <div className="row mt-2 p-0">
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
             
   
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>Full Name</Tooltip>)}>
                <input type="text" name="fullName" {...register("fullName", { required: "Full Name required" })} placeholder="Full Name" className={`form-control basic-form ${errors.fullName ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.fullName?.message}</div>
            <div className="mt-4">      
                    <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>  Email</Tooltip>)}>
                <input type="email" name="email" {...register("email", { required: "Email required" })} placeholder="Email  " className={`form-control basic-form ${errors.email ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback">{errors.email?.message}</div>
         
         </div>
       
            </div>
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Mobile Number</Tooltip>)}>

                <input
                  placeholder='Mobile Number'
                  type="Number"
                  min="0"
                  title=''
                  name="phoneNumber"
                  disabled={isDisabled}
                  {...register("phoneNumber", { required: "Mobile Number Required" })}
                  className={`form-control basic-form ${errors.phoneNumber ? 'is-invalid' : ''}`}

                />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.phoneNumber?.message}</div>
              <div className="mt-4"> 
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}>linkedin Url</Tooltip>)}>
                <input type="text" title="" name="linkdinUrl" {...register("linkdinUrl", { required: "Linkedin URL required" })} placeholder="Linkedin URL" className={`form-control basic-form ${errors.linkdinUrl ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback">{errors.linkdinUrl?.message}</div>
         </div>
           </div>

          </div>
         
    
          <div className="row mt-4 p-0">
            <div className="col-12">
             
            <Link to="/Employer/Dashboard">  <button  style={{float:"right"}}  disabled={isSubmitting || isDisabled} className="btn btn-primary ">
                Cancel
              </button>
              </Link>
              <button style={{float:"right"}} disabled={isSubmitting || isDisabled} className="btn btn-primary mr-3">
                {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                Save
              </button> &nbsp;&nbsp;&nbsp;
            </div>


          </div>

        </form>
              </div>

      }
    </section>
  </ConsultantLayout>
  );
}

export default Masking;